import { render, staticRenderFns } from "./pipe-pass.vue?vue&type=template&id=4d7e2e9a"
import script from "./pipe-pass.vue?vue&type=script&lang=js"
export * from "./pipe-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports